import { useState } from 'react'

import { viewVisibilities } from '@/common/components/FilterViews/ViewVisibilityFields/constants'
import { getSelectedGroups } from '@/common/components/FilterViews/ViewVisibilityFields/helpers'

const useViewVisibility = ({ initialVisibility, initialSelectedGroupIds, groups, fixedGroupIds, canSelectGroups }) => {
  const [visibility, setVisibility] = useState(initialVisibility)
  const [selectedGroupIds, setSelectedGroupIds] = useState(initialSelectedGroupIds)

  const toggleGroup = groupId => {
    if (fixedGroupIds.includes(groupId)) return

    setSelectedGroupIds(ids => {
      return ids.includes(groupId) ? ids.filter(id => id !== groupId) : [...ids, groupId]
    })
  }

  const isShared = visibility === viewVisibilities.shared
  const selectedGroups = getSelectedGroups(groups, selectedGroupIds)

  return {
    visibility,
    setVisibility,
    selectedGroupIds,
    toggleGroup,
    selectedGroups,
    showSharedGroupsAlert: isShared && selectedGroups.length > 0,
    showGroupsWithAccess: isShared && canSelectGroups,
    isVisibilityValid: !isShared || selectedGroupIds.length > 0,
    sharedWithGroups: isShared ? selectedGroupIds : [],
  }
}

export default useViewVisibility
